import {
  reverse_geocode as nominatim_reverse_geocode,
  forward_geocode as nominatim_forward_geocode,
  parseGeocodeResponse as nominatim_parseGeocodeResponse,
} from 'utils/nominatim'

import MapboxGeocodingAdapter from 'utils/MapboxGeocodingAdapter'

let mapboxGeocodingAdapter
if (
  process.env.REACT_APP_MAPBOX_ACCESS_TOKEN &&
  process.env.REACT_APP_MAPBOX_GEOCODER_BASE_URL
) {
  mapboxGeocodingAdapter = new MapboxGeocodingAdapter()
  console.info('Mapbox Geocoding Adapter configured')
} else {
  console.info('Using Nominatim Geocoding Adapter')
}

const isMapboxGeocoderEnabled = () => Boolean(mapboxGeocodingAdapter)

export const isSearchOnTypeEnabled = () =>
  isMapboxGeocoderEnabled() &&
  process.env.REACT_APP_SEARCH_ADDRESS_ON_TYPE === 'true'

export const reverse_geocode = (lon, lat) => {
  if (mapboxGeocodingAdapter) {
    return mapboxGeocodingAdapter.reverseGeocode({
      longitude: lon,
      latitude: lat,
    })
  }
  return nominatim_reverse_geocode(lon, lat)
}

export const forward_geocode = (address, options = {}) => {
  if (mapboxGeocodingAdapter) {
    return mapboxGeocodingAdapter.searchLocations(address, options)
  }
  return nominatim_forward_geocode(address, options)
}

export const parseGeocodeResponse = (data, lngLat) => {
  if (mapboxGeocodingAdapter) {
    return mapboxGeocodingAdapter.parseGeocodeResponse(data, lngLat)
  }
  return nominatim_parseGeocodeResponse(data, lngLat)
}
